const saveObject = <TValue = unknown>(key: string, value: TValue) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export { saveObject };
